module.exports = __webpack_public_path__ + "static/media/mc.2ecad681.svg";